var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderDeskBikePedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 142,
    viewBox: "0 0 180 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.465 36.0947L116.262 32.1406L116.236 40.0918L109.448 44.0373L109.465 36.0947Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.254 32.4591L110.051 28.5137L116.262 32.1404L109.465 36.0944L103.254 32.4591Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.465 36.0943L109.448 44.0369L103.229 40.4102L103.254 32.459L109.465 36.0943Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.967 69.8117L173.764 65.8662L173.738 73.8088L166.941 77.7542L166.967 69.8117Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.473 36.0947L116.261 32.1406L173.762 65.8664L166.966 69.8119L109.473 36.0947Z",
    fill: "#4A4861"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.966 69.8119L166.94 77.7545L109.447 44.0373L109.473 36.0947L166.966 69.8119Z",
    fill: "#7A7C95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.204 73.4472L180 69.4932L179.974 77.4443L173.178 81.3898L173.204 73.4472Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.983 69.8117L173.78 65.8662L180 69.4929L173.203 73.447L166.983 69.8117Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.204 73.4468L173.178 81.3894L166.967 77.7627L166.984 69.8115L173.204 73.4468Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.881 112.169L40.0928 108.224L40.11 116.166L46.9069 120.12L46.881 112.169Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.966 56.2609L137.247 52.126L40.0928 108.224L46.881 112.169L143.966 56.2609Z",
    fill: "#4A4861"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8809 112.169L46.9067 120.12L143.872 64.2549L143.846 56.3037L46.8809 112.169Z",
    fill: "#5D6081"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0499 108.206L33.2617 104.252L33.2789 112.203L40.0758 116.149L40.0499 108.206Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.592 52.1256L130.528 48.249L33.2617 104.252L40.0499 108.206L137.592 52.1256Z",
    fill: "#4A4861"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23677 95.8107L13.0336 91.8652L13.0078 99.8164L6.21094 103.762L6.23677 95.8107Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0175781 92.1837L6.81443 88.2383L13.0341 91.865L6.23725 95.8104L0.0175781 92.1837Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23689 95.8103L6.21106 103.761L0 100.126L0.01723 92.1836L6.23689 95.8103Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7387 129.536L70.527 125.582L70.5097 133.533L63.7129 137.479L63.7387 129.536Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23535 95.8193L13.0322 91.8652L70.5254 125.582L63.7372 129.536L6.23535 95.8193Z",
    fill: "#4A4861"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7378 129.537L63.712 137.479L6.21875 103.762L6.23597 95.8193L63.7378 129.537Z",
    fill: "#7A7C95"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9674 133.172L76.7643 129.218L76.747 137.169L69.9502 141.114L69.9674 133.172Z",
    fill: "#333333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7559 129.536L70.5527 125.591L76.7637 129.218L69.9669 133.172L63.7559 129.536Z",
    fill: "#1A1A1A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9664 133.171L69.9492 141.114L63.7295 137.487L63.7553 129.536L69.9664 133.171Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9364 2.00781L53.9278 5.60006L50.8438 6.73719L50.8524 3.14492L53.9364 2.00781Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8517 3.14453L50.843 6.7368L49.6025 7.46041L49.6112 3.86816L50.8517 3.14453Z",
    fill: "#333333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6105 3.86816L49.6019 7.46041L47.6895 9.22639L47.6981 5.63414L49.6105 3.86816Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9442 9.51965L66.9356 13.1119L53.9277 5.60005L53.9363 2.00781L66.9442 9.51965Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4147 9.19141L70.4061 12.775L67.8906 15.6781L67.8992 12.0945L70.4147 9.19141Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8992 12.0947L67.8906 15.6784L65.1426 17.2807L65.1512 13.697L67.8992 12.0947Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.146 15.1614L60.1288 18.745L44.2178 9.55337L44.2264 5.96973L60.146 15.1614Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0638 11.811L52.2555 3.20508C52.0057 3.05863 51.6525 3.07585 51.2734 3.29983L66.0818 11.9057C66.4608 11.6818 66.814 11.6645 67.0638 11.811Z",
    fill: "#606060"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2917 6.58096L65.1 15.1868C64.8501 15.0404 64.6951 14.7389 64.6951 14.2995C64.6951 13.4209 65.3153 12.3527 66.0734 11.9047L51.2651 3.29883C50.4984 3.73817 49.8782 4.81499 49.8868 5.69367C49.8868 6.12439 50.0419 6.43452 50.2917 6.58096Z",
    fill: "#606060"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1224 13.7487C68.1224 14.5584 67.5538 15.5492 66.8474 15.954C66.365 16.2297 65.9429 16.1694 65.7275 15.8334C65.9343 15.8851 66.1927 15.8334 66.4684 15.6784C67.1748 15.2735 67.7433 14.2828 67.7433 13.473C67.7433 13.2232 67.683 13.0164 67.5883 12.8613C67.907 12.9389 68.1224 13.2576 68.1224 13.7487Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7441 13.4728C67.7441 14.2826 67.1755 15.2733 66.4692 15.6781C66.1935 15.8332 65.9351 15.8849 65.7283 15.8332C65.6249 15.6868 65.5732 15.48 65.5732 15.2216C65.5732 14.4118 66.1418 13.4297 66.8482 13.0162C67.1239 12.8612 67.3737 12.8095 67.589 12.8612C67.6838 13.0162 67.7441 13.223 67.7441 13.4728Z",
    fill: "#1A1A1A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.415 9.1917L67.9082 12.0948L65.1601 13.6971L60.1551 15.1615L44.2441 5.96986L46.7596 3.06677L49.5076 1.46447L54.5126 0L70.415 9.1917ZM63.7474 12.0345L64.9965 11.3109L66.952 9.51903L53.9441 2.00718L50.8601 3.1443L49.611 3.86793L47.6986 5.6339L60.7065 13.1457L63.7474 12.0345Z",
    fill: "#1A1A1A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1502 13.6973L65.1416 17.2809L60.1279 18.7454L60.1452 15.1617L65.1502 13.6973Z",
    fill: "#333333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0255 43.7881L76.1253 46.7859C75.7979 46.5964 75.5998 46.1915 75.5998 45.623C75.5998 44.4686 76.4096 43.0731 77.4088 42.4959L72.309 39.498C71.3098 40.0752 70.5 41.4794 70.5 42.6251C70.5 43.1937 70.6981 43.5985 71.0255 43.7881Z",
    fill: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4087 42.4865C76.4094 43.0636 75.5996 44.4678 75.5996 45.6135C75.5996 46.7678 76.418 47.233 77.4173 46.6472C78.4165 46.0701 79.2263 44.6659 79.2263 43.5116C79.2263 42.3745 78.4079 41.9093 77.4087 42.4865Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2054 15.6443L68.1057 12.6464C67.7783 12.4569 67.3217 12.4827 66.8135 12.7756L71.9133 15.7735C72.4215 15.4806 72.8781 15.4547 73.2054 15.6443Z",
    fill: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5384 17.0654L70.6382 20.0633C70.3109 19.8737 70.1127 19.4689 70.1127 18.9003C70.1127 17.746 70.9225 16.3504 71.9218 15.7732L66.822 12.7754C65.8227 13.3526 65.013 14.7567 65.013 15.9025C65.0043 16.4796 65.2111 16.8759 65.5384 17.0654Z",
    fill: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9135 15.7731C70.9143 16.3503 70.1045 17.7545 70.1045 18.9002C70.1045 20.0546 70.9229 20.5197 71.9221 19.934C72.9214 19.3568 73.7312 17.9526 73.7312 16.7982C73.7312 15.6525 72.9128 15.1873 71.9135 15.7731Z",
    fill: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3972 43.986L69.4589 42.8661L69.4072 17.2207L71.3455 18.3492L71.3972 43.986Z",
    fill: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7233 16.9707L73.775 42.6161L71.3974 43.9858L71.3457 18.349L73.7233 16.9707Z",
    fill: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7972 25.3087L107.285 34.888C102.117 31.8815 94.958 32.3123 87.0499 36.8693L70.5703 27.2901C78.4698 22.733 85.6285 22.3023 90.7972 25.3087Z",
    fill: "#9290A0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3419 102.185L47.8538 92.6052C44.3304 89.1939 42.2371 83.6633 42.2199 76.3755C42.1682 58.3195 54.8574 36.3525 70.5616 27.29L87.0498 36.8694C71.3455 45.9404 58.6564 67.9074 58.708 85.9548C58.7339 93.2513 60.8272 98.7732 64.3419 102.185Z",
    fill: "#9290A0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0499 36.8697C102.754 27.7987 115.529 35.0779 115.573 53.1253C115.59 60.4132 113.539 68.3385 110.042 75.7986L64.342 102.185C60.8187 98.7735 58.7254 93.243 58.7082 85.9551C58.6565 67.9078 71.3456 45.9408 87.0499 36.8697Z",
    fill: "#6F6C8A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5331 54.9871C96.5667 53.2216 96.6123 51.3267 95.6352 50.7546C94.658 50.1826 93.028 51.1501 91.9944 52.9156C90.9609 54.6811 90.9152 56.576 91.8924 57.1481C92.8696 57.7201 94.4996 56.7526 95.5331 54.9871Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2801 56.0097C99.3351 52.4992 99.4267 48.7318 97.4847 47.5949C95.5426 46.458 92.3023 48.3822 90.2473 51.8927C88.1923 55.4032 88.1007 59.1707 90.0428 60.3075C91.9848 61.4444 95.2251 59.5202 97.2801 56.0097Z",
    stroke: "#3F3D59",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.463 54.9431L95.3986 51.3851C95.0024 51.1612 94.4596 51.187 93.8652 51.5316L99.9298 55.0896C100.524 54.7536 101.067 54.7191 101.463 54.9431Z",
    fill: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3408 56.6396L98.4054 60.1974C98.0178 59.9735 97.7766 59.4911 97.7766 58.8105C97.7766 57.4408 98.7328 55.7782 99.9216 55.089L93.857 51.5312C92.6682 52.2204 91.7034 53.883 91.712 55.2527C91.7206 55.9419 91.9532 56.4157 92.3408 56.6396Z",
    fill: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9292 55.0977C98.7404 55.7869 97.7756 57.4495 97.7842 58.8192C97.7842 60.1889 98.7577 60.7403 99.9464 60.0511C101.135 59.3619 102.1 57.6993 102.091 56.3296C102.083 54.9599 101.118 54.4085 99.9292 55.0977Z",
    fill: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2313 87.6433L96.9312 86.2994L96.8623 55.8213L99.1624 57.1565L99.2313 87.6433Z",
    fill: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.996 55.5283L102.057 86.0065L99.231 87.6432L99.1621 57.1565L101.996 55.5283Z",
    fill: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.329 81.1055L107.32 85.3697L103.659 86.7135L103.668 82.458L107.329 81.1055Z",
    fill: "#333333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 82.458L103.659 86.7136L102.178 87.575L102.186 83.3108L103.668 82.458Z",
    fill: "#333333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.185 83.3105L102.177 87.5747L99.9023 89.6767L99.911 85.4125L102.185 83.3105Z",
    fill: "#333333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M122.801 90.0301L122.783 94.2943L107.32 85.3697L107.329 81.1055L122.801 90.0301Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126.918 89.6328L126.909 93.897L123.92 97.3514L123.937 93.0872L126.918 89.6328Z",
    fill: "#333333"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123.936 93.0879L123.919 97.3521L120.646 99.2559L120.663 94.9917L123.936 93.0879Z",
    fill: "#333333"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M114.712 96.7318L114.695 100.996L95.7773 90.0728L95.7946 85.8086L114.712 96.7318Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.939 92.7433L105.34 82.5179C105.038 82.3456 104.625 82.3714 104.168 82.6299L121.767 92.8553C122.224 92.5969 122.637 92.571 122.939 92.7433Z",
    fill: "#606060"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M103.005 86.5322L120.604 96.7577C120.311 96.5854 120.122 96.2236 120.122 95.6981C120.122 94.6557 120.854 93.3808 121.767 92.8553L104.168 82.6299C103.255 83.1554 102.522 84.4303 102.522 85.4727C102.522 85.9982 102.703 86.36 103.005 86.5322Z",
    fill: "#606060"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M124.204 95.0521C124.204 96.017 123.532 97.1886 122.697 97.671C122.119 98.007 121.62 97.9208 121.361 97.5332C121.611 97.5935 121.913 97.5332 122.24 97.3522C123.076 96.8698 123.756 95.6982 123.748 94.7334C123.748 94.4319 123.679 94.1907 123.558 94.0098C123.946 94.0959 124.196 94.4663 124.204 95.0521Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M123.74 94.7338C123.74 95.6986 123.068 96.8702 122.232 97.3526C121.905 97.5421 121.603 97.5938 121.354 97.5335C121.233 97.3526 121.164 97.1114 121.164 96.8099C121.164 95.8451 121.836 94.6735 122.672 94.1911C122.999 94.0016 123.3 93.9499 123.55 94.0102C123.679 94.1825 123.74 94.4323 123.74 94.7338Z",
    fill: "#1A1A1A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.918 89.6341L123.938 93.0885L120.664 94.9923L114.711 96.7325L95.7939 85.8093L98.7832 82.3549L102.057 80.4511L108.009 78.7109L126.918 89.6341ZM118.993 93.0196L120.475 92.1582L122.792 90.0304L107.329 81.1058L103.668 82.4582L102.186 83.3197L99.9117 85.4216L115.375 94.3463L118.993 93.0196Z",
    fill: "#1A1A1A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M120.663 94.9912L120.646 99.2554L114.693 100.996L114.711 96.7313L120.663 94.9912Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderDeskBikePedal);
export default __webpack_public_path__ + "static/media/UnderDeskBikePedal.031df1e38ae092c8e75f50bd0f3f8fa6.svg";
export { ForwardRef as ReactComponent };